import React from 'react';
import './App.css';
import Leaderboard from './Leaderboard'; // Import your new file

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <h1>DayZ Stalker Leaderboard</h1>
      </header>
      <main>
        <Leaderboard /> 
      </main>
    </div>
  );
}

export default App;